"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  VideoChat: true,
  VideoAnchor: true,
  TestVideoLink: true,
  JoinCallButtonTimeRangeWarning: true,
  JoinCallButton: true,
  ForceFinishCallDialog: true,
  WrongBrowserAlert: true,
  VideoChatProvider: true
};
Object.defineProperty(exports, "ForceFinishCallDialog", {
  enumerable: true,
  get: function get() {
    return _ForceFinishCallDialog.default;
  }
});
Object.defineProperty(exports, "JoinCallButton", {
  enumerable: true,
  get: function get() {
    return _JoinCallButton.default;
  }
});
Object.defineProperty(exports, "JoinCallButtonTimeRangeWarning", {
  enumerable: true,
  get: function get() {
    return _JoinCallButtonTimeRangeWarning.default;
  }
});
Object.defineProperty(exports, "TestVideoLink", {
  enumerable: true,
  get: function get() {
    return _TestVideoLink.default;
  }
});
Object.defineProperty(exports, "VideoAnchor", {
  enumerable: true,
  get: function get() {
    return _VideoAnchor.default;
  }
});
Object.defineProperty(exports, "VideoChat", {
  enumerable: true,
  get: function get() {
    return _VideoChat.default;
  }
});
Object.defineProperty(exports, "VideoChatProvider", {
  enumerable: true,
  get: function get() {
    return _VideoChatContext.default;
  }
});
Object.defineProperty(exports, "WrongBrowserAlert", {
  enumerable: true,
  get: function get() {
    return _WrongBrowserAlert.WrongBrowserAlert;
  }
});
var _VideoChat = _interopRequireDefault(require("./VideoChat"));
var _VideoAnchor = _interopRequireDefault(require("./VideoAnchor"));
var _TestVideoLink = _interopRequireDefault(require("./Video/TestVideoLink"));
var _JoinCallButtonTimeRangeWarning = _interopRequireDefault(require("./Video/JoinCallButtonTimeRangeWarning"));
var _JoinCallButton = _interopRequireDefault(require("./Video/JoinCallButton"));
var _ForceFinishCallDialog = _interopRequireDefault(require("./Video/ForceFinishCallDialog"));
var _WrongBrowserAlert = require("./Video/WrongBrowserAlert");
var _VideoChatContext = _interopRequireWildcard(require("./VideoChatContext"));
Object.keys(_VideoChatContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _VideoChatContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _VideoChatContext[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }